<template>
  <div :class="['flex flex-col py-4 gap-2 border-b border-app-gray-200 h-auto', { 'px-5': padding }]">
    <div class="flex items-center gap-2">
      <Badge :variant="typeColor" class="capitalize">{{ item.type }}</Badge>
      <p class="text-xs font-normal text-app-gray-400">{{ formattedLiveDate }}</p>
      <div v-if="!hideDot && !item.is_read" class="h-2 w-2 bg-app-red-500 rounded-full"></div>
    </div>
    <h3 class="text-base font-semibold text-app-gray-900 w-5/6">{{ item.title }}</h3>
    <p class="text-sm font-normal text-app-gray-500">
      {{ item.description }}
      <Button variant="secondary" size="xs" class="text-sm! ml-2 h-5!" component="span" aria-hidden @click="toggleDisplay()">
        {{ displayed ? "Show less" : "Show more" }}
      </Button>
    </p>
    <div v-if="displayed" v-dompurify-html="item.details" class="text-sm font-normal text-app-gray-500 item-details"></div>
  </div>
</template>

<script lang="ts">
import { Badge } from "@toruslabs/vue-components/Badge";
import { defineComponent } from "vue";

import { Button } from "@/components/Button";
import { notificationModule } from "@/store";

export default defineComponent({
  name: "NotificationItem",
  components: { Badge, Button },
  props: {
    item: {
      type: Object,
      required: true,
    },
    hideDot: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    displayed: false,
  }),
  computed: {
    typeColor() {
      switch (this?.item?.type) {
        case "feature":
          return "warning";
        case "announcement":
          return "info";
        case "bug fix":
          return "success";
        default:
          return "info";
      }
    },
    formattedLiveDate() {
      const date = new Date(this.item.live_at);
      const formattedDate = date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      return formattedDate;
    },
  },
  methods: {
    async toggleDisplay() {
      this.displayed = !this.displayed;
      if (!this.item.is_read) {
        await notificationModule.markNotificationsAsRead([this.item.ID]);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use "NotificationItem.scss";
</style>
